import React from 'react'
import FormProgress from '../../../../../library/form/components/FormProgress';
import FormROValue from '../../../../../library/form/components/FormROValue1';
import FormWrapper from '../../../../../library/form/components/FormWrapper';
import { UiClear } from '../../../../../library/layout/Index';
import SarasTrans from '../../../../../library/notifications/SarasTrans';

const ProdTaskRow = (props) => {
    const { formObject, rowKey, onRowClick, selectedTask } = props;

    return (
        <li onClick={() => onRowClick(rowKey)} 
            className={selectedTask === rowKey ? "uiSelectedListRow" : "uiListRow"}>
            <div>
                <div>
                    <FormROValue className="uiBlue" format="#" formObject={formObject} style={{display:'block'}}
                    rowKey={rowKey} action={{ paramName: "processName" }}/>
                    <FormROValue className="uiUnHighlight uiGrey" format="#" formObject={formObject} style={{display:'block'}}
                    rowKey={rowKey} action={{ paramName: "allocatedTo" }}/>
                </div>
                <FormWrapper customWrapper="div" wrapperClass="uiResetFloats" formObject={formObject} rowKey={rowKey} action={{ paramName: "taskInfoContainer" }}>
                    <div>
                        <span className="uiBold"><SarasTrans value="Qty" /></span>
                        <FormROValue className="uiSpacerH5" format="" formObject={formObject} rowKey={rowKey} action={{ paramName: "qty" }}/>
                        <span className="uiBold"><SarasTrans value="On" /></span>
                        <FormROValue className="uiSpacerL5" format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "issueReturn" }}/>
                    </div>
                    <div style={{height:'45px'}}>
                        <div className='uiFloatLeft' style={{width:'135px'}}>
                            <UiClear></UiClear>
                            <div>
                                <span className="uiBold"><SarasTrans value="Est" /></span>
                                <FormROValue className="uiSpacerH5" format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "estTime" }}/>
                                <span className="uiBold"><SarasTrans value="Act" /></span>
                                <FormROValue className="uiSpacerL5" format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "actTime" }}/>
                            </div>
                            <div>
                                <FormROValue className="uiUnHighlight uiBlue uiComfortText" 
                                    format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "status" }}/>
                            </div>
                        </div>
                        <div className='uiFloatRight' style={{width:'41px'}}>
                            <UiClear></UiClear>
                            <FormProgress formObject={formObject} rowKey={rowKey} progressType="circle" over100IsDelay
                                action={{ paramName: "percentComplete" }} progressClass="uiBlue" delayClass="uiRed"/>
                        </div>
                    </div>
                </FormWrapper>
            </div>
        </li>
    )
}

export default ProdTaskRow